import { render, staticRenderFns } from "./TextAlignLeftIcon.vue?vue&type=template&id=c5e73ea6&"
import script from "./TextAlignLeftIcon.vue?vue&type=script&lang=js&"
export * from "./TextAlignLeftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports